export default __webpack_public_path__ + "static/media/2026_April_Baum.53648059.webp";